import {
	ContractAssigned,
	ContractHoldStatus,
	ContractHoldStatusId,
	ContractStatus,
	ContractStatusId,
	ContractTerminationStatus,
	ContractTerminationStatusId,
	ModulePhase,
} from "./enums/contract-detail";
import {
	editSquarePrimaryIcon,
	amountIcon,
	editIcon,
	handShakeIcon,
	moneyIcon,
	refreshIcon,
	deleteIcon,
	circleTickGreenIcon,
	crossPrimaryIcon,
	magnifyingGlassPrimaryIcon,
	notesPrimaryIcon,
	notesTickPrimaryIcon,
	refreshPrimaryIcon,
	contractExpiredIn12Months,
	contractExpiredIn1Months,
	contractExpiredIn3Months,
	contractExpiredIn8Months,
	contractExpiredIn6Months,
	errorIcon,
} from "assets/images";
import { ContractService } from "services/contractManagement.service";
import { IOption } from "./interfaces/select-option";
import {
	AddUpdateContractLineModel,
	ContractCompanyWideLineModel,
	ContractLineDetailByDeptModel,
	ContractLineFinYearDetailByCompanyWide,
	ContractLineModel,
	ContractLineModelByCompanyWide,
} from "models/ContractManagement/ContractLineDetailModel";
import { Shared } from "./shared";
import { format } from "date-fns";
import {
	defaultDivisionGridLabel,
	defaultRegionGridLabel,
} from "redux/authStateSlice";
import { SupplierData } from "models/SupplierUserModel";
import { ContractType } from "./enums/requisition-entry";
import { isEqual } from "lodash";
import { GridActionParams } from "models/CustomDataGrid/GridActionParams";
import { TableFilterModel } from "models/TableFilterModel";
import { AppRoutings } from "./enums/app-routings";
import { MenuName } from "./enums/user-access-right";

enum ExpireInOptionEnum {
	Months_18 = 540,
	Months_12 = 360,
	Months_6 = 180,
	Months_3 = 90,
	Months_1 = 30,
	Week_3 = 21,
	Week_2 = 14,
	Week_1 = 7,
	CurrentMonth = new Date().getDate(),
	CurrentWeek = new Date().getDay(),
}

export type ContractGridTileType = {
	name: string;
	countFiledName: string;
	amountFieldName: string;
	caption: string;
	caption2?: string;
	icon: string;
	captionFieldName?: string;
	caption2FieldName?: string;
	percentVariationFieldName?: string;
	amountFieldName2?: string;
	redirectToRoute?: string;
	pageName?: string;
	moduleName?: string;
};

type DialogContext = "PO" | "Variation";

type DialogKey =
	| ContractHoldStatus.HoldRequest
	| ContractHoldStatus.HoldRemovalRequest
	| ContractHoldStatus.OnHold
	| ContractTerminationStatus.TerminationRequest
	| ContractTerminationStatus.Terminated;

interface DialogConfigEntry {
	title: string;
	message: string;
}

type DialogAction =
	| "DELETE"
	| "COPY"
	| "EDIT"
	| "APPROVE"
	| "REJECT"
	| "CHANGE_REQUEST"
	| "RECALL"
	| "DELEGATE"
	| "TASK_COMPLETE";
type DialogContextForAlert =
	| "Purchase Requests"
	| "Purchase Orders"
	| "Variations";

class ContractManagementUtilInternal {
	getContractStatusList = () => {
		const temp: any = [];
		Object.keys(ContractStatusId)
			.filter((key) => !isNaN(Number((ContractStatusId as any)[key])))
			.forEach((el: any) => {
				temp.push({
					label: (ContractStatus as any)[el],
					value: ContractStatusId[el].toString(),
				});
			});
		return temp;
	};
	contractStatusList: IOption[] = this.getContractStatusList();

	expiresInList = [
		{
			label: "18 Months",
			value: ExpireInOptionEnum.Months_18.toString(),
		},
		{
			label: "12 Months",
			value: ExpireInOptionEnum.Months_12.toString(),
		},
		{
			label: "6 Months",
			value: ExpireInOptionEnum.Months_6.toString(),
		},
		{
			label: "3 Months",
			value: ExpireInOptionEnum.Months_3.toString(),
		},
		{
			label: "1 Month",
			value: ExpireInOptionEnum.Months_1.toString(),
		},
		{
			label: "This Month",
			value: ExpireInOptionEnum.CurrentMonth.toString(),
		},
		{
			label: "3 Weeks",
			value: ExpireInOptionEnum.Week_3.toString(),
		},
		{
			label: "2 Weeks",
			value: ExpireInOptionEnum.Week_2.toString(),
		},
		{
			label: "1 Week",
			value: ExpireInOptionEnum.Week_1.toString(),
		},
		{
			label: "This Week",
			value: ExpireInOptionEnum.CurrentWeek.toString(),
		},
	];

	assignedToList = [
		{
			label: "Assigned To Me",
			value: ContractAssigned.AssignedToMe.toString(),
		},
		{
			label: "Created By Me",
			value: ContractAssigned.CreatedByMe.toString(),
		},
		{
			label: "Created By Others",
			value: ContractAssigned.CreatedByOthers.toString(),
		},
	];

	gridTilesData: ContractGridTileType[] = [
		{
			name: "Total Original Contract Amount",
			countFiledName: "totalContract",
			amountFieldName: "contractAmount",
			caption: "Awarder Contracts YTD",
			icon: editIcon,
		},
		{
			name: "Total Variation",
			countFiledName: "totalVariation",
			amountFieldName: "variationAmount",
			percentVariationFieldName: "percentVariation",
			caption: "Approved Variations YTD",
			icon: refreshIcon,
		},
		{
			name: "Current Contract",
			countFiledName: "totalCurrentContract",
			amountFieldName: "currentContractAmount",
			caption: "Adjusted Contract Amount YTD",
			icon: editIcon,
		},
		{
			name: "Remaining PO Amount",
			countFiledName: "totalRemainingPO",
			amountFieldName: "remainingPOAmount",
			caption: "PR Total ",
			caption2: "PO Total ",
			icon: handShakeIcon,
			captionFieldName: "prTotalAmount",
			caption2FieldName: "poTotalAmount",
		},
		{
			name: "Total Expenditure",
			countFiledName: "totalExpenditure",
			amountFieldName: "expenditureAmount",
			caption: "Unpaid ",
			caption2: "Paid ",
			captionFieldName: "unpaidAmount",
			caption2FieldName: "paidAmount",
			icon: moneyIcon,
		},
		{
			name: "Remaining Contract Amount ",
			countFiledName: "totalRemainingContract",
			amountFieldName: "remainingContractAmount",
			caption: "Remaining Amount",
			icon: amountIcon,
		},
	];

	dashboardGridTilesData1: ContractGridTileType[] = [
		{
			name: "Total Original Contract Amount",
			countFiledName: "totalContract",
			amountFieldName: "contractAmount",
			caption: "Awarder Contracts YTD",
			icon: editIcon,
			redirectToRoute: AppRoutings.ContractSummaryGrid,
			pageName: MenuName.ContractSummaryGrid,
		},
		{
			name: "Total Variation",
			countFiledName: "totalVariation",
			amountFieldName: "variationAmount",
			percentVariationFieldName: "percentVariation",
			caption: "Approved Variations YTD",
			icon: refreshIcon,
			redirectToRoute: AppRoutings.VariationSummaryGrid,
			pageName: MenuName.VariationSummaryGrid,
		},
		{
			name: "Current Contract",
			countFiledName: "totalCurrentContract",
			amountFieldName: "currentContractAmount",
			caption: "Adjusted Contract Amount YTD",
			icon: editIcon,
			redirectToRoute: AppRoutings.ContractSummaryGrid,
			pageName: MenuName.ContractSummaryGrid,
		},
		{
			name: "Remaining PO Amount",
			countFiledName: "totalRemainingPO",
			amountFieldName: "remainingPOAmount",
			caption: "PR Total ",
			caption2: "PO Total ",
			icon: handShakeIcon,
			captionFieldName: "prTotalAmount",
			caption2FieldName: "poTotalAmount",
		},
		{
			name: "Total Expenditure",
			countFiledName: "totalExpenditure",
			amountFieldName: "expenditureAmount",
			caption: "Unpaid ",
			caption2: "Paid ",
			captionFieldName: "unpaidAmount",
			caption2FieldName: "paidAmount",
			icon: moneyIcon,
			redirectToRoute: AppRoutings.ExpenditureSummaryGrid,
			pageName: MenuName.ExpenditureSummaryGrid,
		},
		{
			name: "Remaining Contract Amount ",
			countFiledName: "totalRemainingContract",
			amountFieldName: "remainingContractAmount",
			caption: "Remaining Amount",
			icon: amountIcon,
			redirectToRoute: AppRoutings.ContractSummaryGrid,
			pageName: MenuName.ContractSummaryGrid,
		},
	];

	dashboardGridTilesData2: ContractGridTileType[] = [
		{
			name: "Contract Expiring in 12-9 months",
			countFiledName: "expiredIn12MonthCount",
			amountFieldName: "expiredIn12MonthContractAmount",
			amountFieldName2: "expiredIn12MonthRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn12Months,
		},
		{
			name: "Contract Expiring in 8-7 months",
			countFiledName: "expiredIn8MonthCount",
			amountFieldName: "expiredIn8MonthContractAmount",
			amountFieldName2: "expiredIn8MonthRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn8Months,
		},
		{
			name: "Contract Expiring in 6-4 months",
			countFiledName: "expiredIn6MonthCount",
			amountFieldName: "expiredIn6MonthContractAmount",
			amountFieldName2: "expiredIn6MonthRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn6Months,
		},
		{
			name: "Contract Expiring in 3-2 months",
			countFiledName: "expiredIn3MonthCount",
			amountFieldName: "expiredIn3MonthContractAmount",
			amountFieldName2: "expiredIn3MonthRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn3Months,
		},
		{
			name: "Contract Expiring in 1 month",
			countFiledName: "expiredIn1MonthCount",
			amountFieldName: "expiredIn1MonthContractAmount",
			amountFieldName2: "expiredIn1MonthRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn1Months,
		},
		{
			name: "Expired Contracts",
			countFiledName: "expiredContractCount",
			amountFieldName: "expiredContractContractAmount",
			amountFieldName2: "expiredContractRemainingAmount",
			caption: "Contract Amount",
			caption2: "Remaining Amount",
			icon: contractExpiredIn12Months,
		},
	];

	getStatusIcon = (status: string) => {
		switch (status) {
			case ContractStatus.Draft:
				return editSquarePrimaryIcon;
			case ContractStatus.Approved:
				return circleTickGreenIcon;
			case ContractStatus.ChangeRequested:
			case ContractStatus.Recalled:
				return refreshPrimaryIcon;
			case ContractStatus.Reviewed:
				return magnifyingGlassPrimaryIcon;
			case ContractStatus.Rejected:
				return crossPrimaryIcon;
			case ContractStatus.RequestForApproval:
				return notesPrimaryIcon;
			case ContractStatus.TaskCompleteRequest:
				return notesTickPrimaryIcon;
			case ContractStatus.Delete:
				return deleteIcon;
			case ContractStatus.Uncertified:
				return errorIcon;
			default:
				break;
		}
	};

	getContractCount = async () => {
		try {
			return await ContractService.getContractCount();
		} catch (error) {
			return 0;
		}
	};

	formatContractLineDetailOnSave = (formData: ContractLineModel) => {
		const model = formData;
		const tempContractLineDetailList =
			model.contractLineDetailList.length > 1
				? model.contractLineDetailList.map((item) => {
						return {
							financialYearId: item.financialYearId,
							qty: Number(item.qty || 0),
							estUnitCost: item.estUnitCost || 0,
							contractLineDetailId:
								item.contractLineDetailId && item.contractLineDetailId > 0
									? item.contractLineDetailId
									: 0,
						};
				  })
				: [
						{
							financialYearId: model.fromFinancialYearId,
							qty: Number(model.contractQty || 0),
							estUnitCost: model.contractEstUnitCost || 0,
							contractLineDetailId:
								model.contractLineDetailList.length > 0
									? model.contractLineDetailList[0].contractLineDetailId
									: 0,
						},
				  ];
		const tempModel: AddUpdateContractLineModel = {
			...model,
			contractLineId: model.contractLineId > 0 ? model.contractLineId : 0,
			qty: Number(model.contractQty || 0),
			estUnitCost: model.contractEstUnitCost || 0,
			contractLineDetailList:
				tempContractLineDetailList && tempContractLineDetailList.length > 0
					? tempContractLineDetailList.filter(
							(d) => d.estUnitCost && d.estUnitCost > 0 && d.qty > 0
					  )
					: [],
		};
		if (tempModel.requiredDate) {
			(tempModel.requiredDate as any) = Shared.getFormattedDate(
				new Date(tempModel.requiredDate),
				"yyyy-MM-dd"
			);
		}
		if (tempModel.createdDate) {
			(tempModel.createdDate as any) = Shared.getFormattedDate(
				new Date(tempModel.createdDate),
				"yyyy-MM-dd"
			);
		}
		return tempModel;
	};

	getContractLineDetailForCompare = (lineDetail: ContractLineModel) => {
		const {
			contractSubTotal,
			contractVat,
			contractTotalEstCost,
			contractLineDetailList,
			...tempContractLineDetail
		} = lineDetail;
		tempContractLineDetail.requiredDate = tempContractLineDetail.requiredDate
			? new Date(lineDetail.requiredDate as Date)
			: null;
		return tempContractLineDetail;
	};

	updateContractLineCompanyWideResponseModel = (
		res: ContractLineModelByCompanyWide
	) => {
		const tempReqLineList: ContractLineFinYearDetailByCompanyWide[] = [];
		for (let index = 0; index < res.contractLineDetailList.length; index++) {
			const departmentList: ContractLineDetailByDeptModel[] = [];
			for (
				let i = 0;
				i < res.contractLineDetailList[index].departments.length;
				i++
			) {
				departmentList.push({
					...new ContractLineDetailByDeptModel(),
					...res.contractLineDetailList[index].departments[i],
				});
			}
			tempReqLineList.push({
				...new ContractLineFinYearDetailByCompanyWide(),
				financialYearId: res.contractLineDetailList[index].financialYearId,
				financialYear: res.contractLineDetailList[index].financialYear || "",
				departments: departmentList,
			});
		}
		const model: ContractLineModelByCompanyWide = {
			...new ContractLineModelByCompanyWide(),
			...res,
			buyingDepartmentId: res.companyWideDepartmentId,
			contractLineDetailList: tempReqLineList,
		};
		return model;
	};

	// returns ContractCompanyWideLineModel for save/update of company wide line item detail
	formatSaveContractLineDetailByCompanyWide = (
		formData: ContractLineModelByCompanyWide,
		copyStates: Record<number, boolean>
	) => {
		let model: ContractCompanyWideLineModel[] = [];
		const deptListLength =
			formData.contractLineDetailList[0].departments.length;
		for (let index = 0; index < deptListLength; index++) {
			const tempReqLineList = formData.contractLineDetailList.map((r) => {
				const estUnitCost = r.departments[index].estUnitCost;
				const qty = r.departments[index].qty;
				return {
					financialYearId: r.financialYearId || 0,
					qty: qty ? Number(qty) : 0,
					estUnitCost: estUnitCost ? Number(estUnitCost.toFixed(2)) : 0,
					contractLineDetailId: r.departments[index].contractLineDetailId,
					isCopy: copyStates[r.financialYearId!] === true,
				};
			});
			const isReqLineListValueEmpty = tempReqLineList.every(
				(r) =>
					(!r.qty || !(r.qty > 0)) && (!r.estUnitCost || !(r.estUnitCost > 0))
			);
			const tempList = tempReqLineList.filter(
				(d) => d.qty && d.qty > 0 && d.estUnitCost && d.estUnitCost > 0
			);
			const qty = tempList.reduce(
				(total, currentValue) => (total = total + Number(currentValue.qty)),
				0
			);
			const subTotal = tempList.reduce(
				(total, currentValue) =>
					(total =
						total +
						Number(currentValue.qty) * Number(currentValue.estUnitCost)),
				0
			);
			const estUnitCost = subTotal / qty;
			if (!isReqLineListValueEmpty)
				model.push({
					contractLineId:
						formData.contractLineDetailList.find(
							(r) => r.departments[index].contractLineId > 0
						)?.departments[index].contractLineId || null,
					contractId: formData.contractId,
					programmeId: formData.programmeId,
					requestingDepartmentId: formData.requestingDepartmentId,
					buyingDepartmentId:
						formData.contractLineDetailList[0].departments[index].departmentId,
					requiredDate: format(
						new Date(formData.requiredDate as any),
						"yyyy-MM-dd"
					) as any,
					itemId: formData.itemId,
					itemAvailabilityId: formData.itemAvailabilityId,
					productDescription: formData.productDescription,
					glAccountId:
						formData.contractLineDetailList[0].departments[index].glAccountModel
							.glAccountId ?? -1,
					fromFinancialYearId: formData.fromFinancialYearId,
					toFinancialYearId: formData.toFinancialYearId,
					qty: qty,
					estUnitCost: Number(estUnitCost.toFixed(2)),
					csdCommodityId: formData.csdCommodityId,
					companyWideDepartmentId: formData.buyingDepartmentId,
					contractLineDetailList: tempList,
					regionId: formData.regionId,
					divisionId: formData.divisionId,
				});
		}
		return model;
	};

	handleUpdateContractError = (
		error: any,
		gridLabel: { region: string; division: string }
	) => {
		Shared.showSnackbarMessage(
			error.badRequestError
				? error.badRequestError
						.replaceAll(defaultRegionGridLabel, gridLabel.region)
						.replaceAll(defaultDivisionGridLabel, gridLabel.division)
				: "Error while updating contract detail, please try again!"
		);
	};

	gridSizeXl = (isRegionEnable: boolean, isDivisionEnable: boolean) => {
		const isDivisionAndRegionEnabled = isRegionEnable && isDivisionEnable;
		const isDivisionOrRegionEnabled = isRegionEnable || isDivisionEnable;
		const commonGridSize = isDivisionAndRegionEnabled
			? 1.5
			: isDivisionOrRegionEnabled
			? 1.7
			: 2;
		return {
			createdBy: commonGridSize,
			divisionIds: isDivisionAndRegionEnabled
				? 1.5
				: isDivisionOrRegionEnabled
				? 1.7
				: 1.5,
			regionIds: isDivisionAndRegionEnabled
				? 1.5
				: isDivisionOrRegionEnabled
				? 1.7
				: 1.5,
			endUserDepartmentId: commonGridSize,
			contractManagerUserId: isDivisionAndRegionEnabled
				? 1.7
				: isDivisionOrRegionEnabled
				? 1.9
				: 2,
			deliveryOrganizationAddressId: commonGridSize,
			requiredDate: commonGridSize,
			attachment: isDivisionAndRegionEnabled
				? 1.3
				: isDivisionOrRegionEnabled
				? 1.5
				: 2,
		};
	};

	checkIfPanelListsDataExist = (
		noOfPanels: number | null,
		contractPanels: SupplierData[],
		contractTypeId: number
	) => {
		if (
			contractTypeId === ContractType.Panel &&
			noOfPanels &&
			noOfPanels > 0 &&
			Number(noOfPanels) !== contractPanels.length
		) {
			Shared.showSnackbarMessage(
				contractPanels.length > 0
					? `You only provided data for ${contractPanels.length} panelists, please enter data for others!`
					: `Please enter data for panelists!`,
				"warning"
			);
			return false;
		}
		return true;
	};

	checkIfContractSupplierBidAttachmentExists = async (
		contractId: number,
		supplierId: number,
		panelNumber: string
	) => {
		try {
			Shared.showLoader(true);
			const res =
				await ContractService.checkIfContractSupplierBidAttachmentExists(
					contractId,
					supplierId,
					panelNumber
				);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error while checking if supplier bid attachments exists, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	isContractLineDetailUpdated = (
		formCurrentValue: ContractLineModel,
		contractLineDetail: ContractLineModel
	) => {
		const {
			itemUomName,
			contractSubTotal,
			contractVat,
			contractTotalEstCost,
			contractLineDetailList,
			...formData // assigns remaining keys to a new `formData` object
		} = formCurrentValue;
		formData.contractQty = Number(formData.contractQty);
		if (formData.glAccountId)
			formData.glAccountId = Number(formData.glAccountId);
		formData.contractEstUnitCost = Number(formData.contractEstUnitCost);
		formData.requiredDate = formData.requiredDate
			? new Date(formData.requiredDate)
			: null;
		// get contract line value
		const tempContractLineDetail =
			ContractManagementUtil.getContractLineDetailForCompare(
				contractLineDetail
			);

		let isDetailUpdated = !isEqual(formData, tempContractLineDetail); // Check if formData and tempContractLineDetail are the same
		if (!isDetailUpdated) {
			// Check if contractLineDetailList is updated
			const formDataContractLineDetailList =
				formCurrentValue.contractLineDetailList;
			if (formDataContractLineDetailList.length > 1) {
				for (let i = 0; i < formDataContractLineDetailList.length; i++) {
					const lineDetail = formDataContractLineDetailList[i];
					const index = contractLineDetail.contractLineDetailList.findIndex(
						(f) => f.financialYearId === lineDetail.financialYearId
					);
					if (index > -1) {
						const isQuantityEqual =
							Number(contractLineDetail.contractLineDetailList[index].qty) ===
							Number(lineDetail.qty);
						const isCostEqual =
							Number(
								contractLineDetail.contractLineDetailList[index].estUnitCost
							) === Number(lineDetail.estUnitCost);

						if (!(isQuantityEqual && isCostEqual)) {
							isDetailUpdated = true;
							break;
						}
					} else if (Number(lineDetail.qty) || Number(lineDetail.estUnitCost)) {
						isDetailUpdated = true;
						break;
					}
				}
			}
		}
		return isDetailUpdated;
	};

	isContractLineDetailUpdatedForCompanyWide = (
		formCurrentValue: ContractLineModelByCompanyWide,
		contractLineDetail: ContractLineModelByCompanyWide
	) => {
		const keyList = [
			"contractLineId",
			"programmeId",
			"requestingDepartmentId",
			"buyingDepartmentId",
			"requiredDate",
			"itemId",
			"csdCommodityId",
			"productDescription",
			"companyWideDepartmentId",
			"regionId",
			"divisionId",
		];
		if (formCurrentValue.requiredDate)
			formCurrentValue.requiredDate = new Date(formCurrentValue.requiredDate);
		if (contractLineDetail.requiredDate)
			contractLineDetail.requiredDate = new Date(
				contractLineDetail.requiredDate
			);

		let isDetailUpdated = false;

		for (let i = 0; i < keyList.length; i++) {
			const key = keyList[i] as any;
			if (
				!isEqual(
					(formCurrentValue as any)[key],
					(contractLineDetail as any)[key]
				)
			) {
				isDetailUpdated = true;
				break;
			}
		}
		if (!isDetailUpdated) {
			const formDataContractLineDetailList =
				formCurrentValue.contractLineDetailList as ContractLineFinYearDetailByCompanyWide[];

			if (formDataContractLineDetailList.length > 0) {
				for (let i = 0; i < formDataContractLineDetailList.length; i++) {
					const lineDetail = formDataContractLineDetailList[i];
					const index = contractLineDetail.contractLineDetailList.findIndex(
						(f) => f.financialYearId === lineDetail.financialYearId
					);
					if (index > -1) {
						const tempLineDeptList =
							contractLineDetail.contractLineDetailList[index].departments;
						for (
							let index = 0;
							index < lineDetail.departments.length;
							index++
						) {
							const deptLine = lineDetail.departments[index];
							const deptIndex = tempLineDeptList.findIndex(
								(f) => f.departmentId === deptLine.departmentId
							);

							if (deptIndex > -1) {
								const isQuantityEqual =
									Number(tempLineDeptList[deptIndex].qty) ===
									Number(deptLine.qty);
								const isCostEqual =
									Number(tempLineDeptList[deptIndex].estUnitCost) ===
									Number(deptLine.estUnitCost);
								if (!isQuantityEqual || !isCostEqual) {
									isDetailUpdated = true;
									break;
								}
							} else if (Number(deptLine.qty) || Number(deptLine.estUnitCost)) {
								isDetailUpdated = true;
								break;
							}
						}
					} else if (Number(lineDetail.qty) || Number(lineDetail.estUnitCost)) {
						isDetailUpdated = true;
						break;
					}
				}
			}
		}
		return isDetailUpdated;
	};
	getFilterModelDetail = (
		gridActionParams: GridActionParams,
		gridFiltersModel: any,
		filterParams: {
			key:
				| "filterField"
				| "filterField_1"
				| "filterField_2"
				| "filterField_3"
				| "filterField_4"
				| "filterField_5"
				| "filterField_6"
				| "filterField_7"
				| "filterField_8"
				| "filterField_9";
			fieldId: string;
			length: number;
			isRequisitionId?: boolean;
		}[]
	) => {
		const filterModel = new TableFilterModel();
		filterModel.pageNo = gridActionParams.pageNumber + 1;
		filterModel.pageSize = gridActionParams.pageSize;
		filterModel.sortType = gridActionParams.order.toUpperCase();
		filterModel.sortBy = gridActionParams.orderBy;
		filterParams.map((param) => {
			return (filterModel[param.key] = param.isRequisitionId
				? param.length === 0
					? ""
					: gridFiltersModel[param.fieldId].length === 0
					? "-1"
					: gridFiltersModel[param.fieldId].length === param.length
					? ""
					: gridFiltersModel[param.fieldId].join(",")
				: Shared.getFilterValue(gridFiltersModel[param.fieldId], param.length));
		});
		return filterModel;
	};

	getContractPaymentsList = async (
		contractId: number,
		filterModel: TableFilterModel
	) => {
		Shared.showLoader(true);
		try {
			Shared.showLoader(true);
			const res = await ContractService.getContractPaymentsList(
				contractId,
				filterModel
			);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error loading Contract Payment list, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	getContractPORequestList = async (
		contractId: number,
		filterModel: TableFilterModel
	) => {
		Shared.showLoader(true);
		try {
			Shared.showLoader(true);
			const res = await ContractService.getPORequestList(
				contractId,
				filterModel
			);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error loading PO Request list, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	getContractVariationList = async (
		contractId: number,
		filterModel: TableFilterModel
	) => {
		Shared.showLoader(true);
		try {
			Shared.showLoader(true);
			const res = await ContractService.getVariationList(
				contractId,
				filterModel
			);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error loading variation list, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	getContractPOList = async (
		contractId: number,
		filterModel: TableFilterModel
	) => {
		Shared.showLoader(true);
		try {
			Shared.showLoader(true);
			const res = await ContractService.getContractPOList(
				contractId,
				filterModel
			);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error loading Contract POs list, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	getUnpaidExpenditureList = async (
		contractId: number,
		filterModel: TableFilterModel
	) => {
		Shared.showLoader(true);
		try {
			Shared.showLoader(true);
			const res = await ContractService.getUnpaidExpenditureList(
				contractId,
				filterModel
			);
			return res;
		} catch (error) {
			Shared.showSnackbarMessage(
				"Error loading Unpaid Expenditur list, please try again!"
			);
			return null;
		} finally {
			Shared.showLoader(false);
		}
	};

	dialogConfig: Record<
		DialogKey,
		Record<DialogContext, DialogConfigEntry | undefined>
	> = {
		[ContractHoldStatus.HoldRequest]: {
			PO: {
				title: "Hold Request Alert",
				message:
					"A hold request has been placed on this contract. Processing of any transactions related to this contract is strictly prohibited until the hold is officially removed.",
			},
			Variation: {
				title: "Hold Request Alert",
				message:
					"A hold request is currently being processed for this contract. New contract variation requests cannot be submitted until the hold is cancelled",
			},
		},
		[ContractHoldStatus.HoldRemovalRequest]: {
			PO: {
				title: "Hold Removal Alert",
				message:
					"A hold removal request is currently being processed for this contract. Processing of any transactions related to this contract is strictly prohibited until the Hold Removal request is approved.",
			},
			Variation: {
				title: "Hold Removal Alert",
				message:
					"A hold removal request is currently being processed for this contract. New contract variation requests cannot be submitted until the Hold Removal request is approved.",
			},
		},
		[ContractHoldStatus.OnHold]: {
			PO: {
				title: "Hold Alert",
				message:
					"This contract has been placed on hold. Processing of any transactions related to this contract is strictly prohibited until the hold is officially removed.",
			},
			Variation: {
				title: "Hold Alert",
				message:
					"This contract is currently on hold. New contract variation requests cannot be submitted until the hold is removed.",
			},
		},
		[ContractTerminationStatus.TerminationRequest]: {
			PO: {
				title: "Termination Request Alert",
				message:
					"A termination request is currently being processed for this contract. New PO requests cannot be submitted until the request is resolved.",
			},
			Variation: {
				title: "Termination Request Alert",
				message:
					"A termination request is currently being processed for this contract. New contract variation requests cannot be submitted until the request is resolved.",
			},
		},
		[ContractTerminationStatus.Terminated]: {
			PO: {
				title: "Terminated Contract Alert",
				message:
					"This contract has been terminated. New PO requests cannot be submitted until the contract is reinstated.",
			},
			Variation: {
				title: "Terminated Contract Alert",
				message:
					"This contract has been terminated. New contract variation requests cannot be submitted until the contract is reinstated.",
			},
		},
	} as const;

	workflowGroupsConfig: { [key: string]: ModulePhase[] } = {
		"PR Workflow": [
			ModulePhase.PRCreation,
			ModulePhase.DepartmentalApproval,
			ModulePhase.SCM_Specification,
			ModulePhase.DOA,
			ModulePhase.FinanceAllocation,
			ModulePhase.DepartmentalAllocation,
			ModulePhase.FinanceConsolidation,
			ModulePhase.Approval,
			ModulePhase.DOA_2,
		],
		"Bid Workflow": [
			ModulePhase.BidCreation,
			ModulePhase.BidSpecification,
			ModulePhase.BidApproval,
			ModulePhase.BidPublishing,
			ModulePhase.BidEvaluation,
			ModulePhase.BidAward,
			ModulePhase.LimitedItemSupplierMappingCreation,
			ModulePhase.LimitedItemSupplierMappingApproval,
			ModulePhase.BidCommitteeChange,
			ModulePhase.BidCommitteeChangeApproval,
			ModulePhase.BidAdjudication,
			ModulePhase.SupplierBidding,
			ModulePhase.ManualBidCapturing,
		],
		"Contract Workflow": [
			ModulePhase.ContractRequest,
			ModulePhase.ContractDrafting,
			ModulePhase.InternalContractReview,
			ModulePhase.ExternalContractReview,
			ModulePhase.ContractApproval,
			ModulePhase.ContractSigning,
			ModulePhase.ContractFiling,
			ModulePhase.ContractExecution,
		],
		"PO Workflow": [
			ModulePhase.POCreation,
			ModulePhase.PODeptApproval,
			ModulePhase.PODoa,
			ModulePhase.POGeneration,
			ModulePhase.POSigning,
			ModulePhase.POCreation_2,
			ModulePhase.PODeptApproval_2,
			ModulePhase.PODoa_2,
			ModulePhase.POGeneration_2,
			ModulePhase.POSigning_2,
		],
		"Variation Workflow": [
			ModulePhase.VariationCreation,
			ModulePhase.VariationDeptApproval,
			ModulePhase.VariationD0A,
			ModulePhase.VariationCreation_2,
			ModulePhase.VariationDeptApproval_2,
			ModulePhase.VariationDOA_2,
		],
		"Hold Workflow": [
			ModulePhase.HoldRequest,
			ModulePhase.HoldRequestReview,
			ModulePhase.HoldRequestApproval,
			ModulePhase.HoldRemovalRequest,
			ModulePhase.HoldRemovalRequestReview,
			ModulePhase.HoldRemovalRequestApproval,
		],
		"Termination Workflow": [
			ModulePhase.TerminationRequest,
			ModulePhase.TerminationRequestReview,
			ModulePhase.TerminationRequestApproval,
			ModulePhase.ReinstatementRequest,
			ModulePhase.ReinstatementRequestReview,
			ModulePhase.ReinstatementRequestApproval,
		],
		// "Reinstatement Workflow": [
		// ModulePhase.ReinstatementRequest,
		// 			ModulePhase.ReinstatementRequestReview,
		// 			ModulePhase.ReinstatementRequestApproval,
		// ],
	};

	getContractStatusLabel = (id: ContractStatusId): ContractStatus => {
		const key = ContractStatusId[id] as keyof typeof ContractStatus;
		return ContractStatus[key];
	};

	getContractHoldStatusLabel = (
		id: ContractHoldStatusId
	): ContractHoldStatus => {
		const key = ContractHoldStatusId[id] as keyof typeof ContractHoldStatus;
		return ContractHoldStatus[key];
	};

	getContractTerminationStatusLabel = (
		id: ContractTerminationStatusId
	): ContractTerminationStatus => {
		const key = ContractTerminationStatusId[
			id
		] as keyof typeof ContractTerminationStatus;
		return ContractTerminationStatus[key];
	};

	actionMap: Record<DialogAction, string> = {
		DELETE: "Deleting existing {subject} is not allowed",
		COPY: "Copying existing {subject} is not allowed",
		EDIT: "Editing existing {subject} is not allowed",
		APPROVE: "Approving existing {subject} is not allowed",
		REJECT: "Rejecting existing {subject} is not allowed",
		CHANGE_REQUEST: "Change requests on existing {subject} are not allowed",
		RECALL: "Recalling existing {subject} is not allowed",
		DELEGATE: "Delegating existing {subject} is not allowed",
		TASK_COMPLETE: "Completing task on existing {subject} is not allowed",
	};

	buildMessage = (
		status: ContractHoldStatus | ContractTerminationStatus | ContractStatus,
		context: DialogContextForAlert,
		action: DialogAction
	) => {
		const messageTemplate = this.actionMap[action].replace(
			"{subject}",
			context
		);

		switch (status) {
			case ContractHoldStatus.HoldRequest:
				return {
					title: "Hold Request Alert",
					message: `A hold request is currently being processed for this contract. ${messageTemplate} until the request is resolved.`,
				};

			case ContractHoldStatus.HoldRemovalRequest:
				return {
					title: "Hold Removal Alert",
					message: `A hold removal request is currently being processed for this contract. ${messageTemplate} until the Hold Removal request is approved.`,
				};

			case ContractStatus.OnHold:
				return {
					title: "Hold Alert",
					message: `This contract is currently on hold. ${messageTemplate} until the hold is removed.`,
				};

			case ContractTerminationStatus.TerminationRequest:
				return {
					title: "Termination Request Alert",
					message: `A termination request is currently being processed for this contract. ${messageTemplate} until the request is resolved.`,
				};

			case ContractStatus.Terminated:
				return {
					title: "Terminated Contract Alert",
					message: `This contract has been terminated. ${messageTemplate} until the contract is reinstated.`,
				};

			default:
				return {
					title: "Contract Alert",
					message: "Action not permitted due to contract status.",
				};
		}
	};
}

export const ContractManagementUtil = new ContractManagementUtilInternal();
